import clsx from 'clsx';
import type { IconProps } from '../components/types.js';
import { fgTone } from '../utils/style/tone.js';
const displayName = 'IconQuery';
/** Renders an SVG icon. */
const SvgQuery = ({ size, 'aria-hidden': ariaHidden, tone, UNSAFE_className, UNSAFE_style, ...rest }: IconProps) => {
  const props = {
    ...rest,
    'aria-hidden': ariaHidden ?? (rest['aria-label'] == null && rest['aria-labelledby'] == null),
    className: clsx('cim-icon', tone && fgTone(tone), UNSAFE_className),
    style: UNSAFE_style,
    width: size != null ? size + 'px' : '1em',
    height: size != null ? size + 'px' : '1em',
  };
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" data-icon="true" fill="currentColor" {...props}>
      <path fill="currentColor" d="M11 14a1 1 0 1 1 0 2H9a1 1 0 1 1 0-2zm2-4a1 1 0 1 1 0 2H9a1 1 0 1 1 0-2z" />
      <path
        fill="currentColor"
        d="M19.947 12V6.99a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1V25a1 1 0 0 0 1 1h6a1 1 0 1 1 0 2H7a3 3 0 0 1-3-3V6.99a3 3 0 0 1 3-3h11.947a3 3 0 0 1 3 3V12a1 1 0 0 1-2 0"
      />
      <path fill="currentColor" d="M28 22a6 6 0 1 0-12 0 6 6 0 0 0 12 0m2 0a8 8 0 1 1-16 0 8 8 0 0 1 16 0" />
      <path fill="currentColor" d="M23.288 25.288a1 1 0 1 1-2 0 1 1 0 0 1 2 0" />
      <path
        fill="currentColor"
        d="M19.288 20.621a2.333 2.333 0 0 1 2.333-2.333h.881c.675 0 1.316.29 1.763.796l.049.055c.744.844.756 2.106.029 2.965-.23.271-.507.5-.817.676l-.09.051a.53.53 0 0 0-.265.457 1 1 0 0 1-2 0c0-.91.489-1.749 1.28-2.197l.089-.05q.16-.091.277-.23a.27.27 0 0 0-.003-.35l-.048-.054a.35.35 0 0 0-.264-.119h-.88a.333.333 0 0 0-.334.333 1 1 0 1 1-2 0"
      />
    </svg>
  );
};
SvgQuery.displayName = displayName;
export default SvgQuery;
